export const SLIDER_CLASSES = {
  "home-hero":"md:-ml-[53px] md:h-[calc(100dvh-53px)]"
}